module.exports = __webpack_public_path__ + "static/media/place.70edf6d4.svg";